import { EllipsisOutlined } from '@ant-design/icons'

import Link from '~/core/Link'
import getColor from '~/lib/getColor'

export const JUMP_PREV_NAVIGATE = 'jump-prev'
export const JUMP_NEXT_NAVIGATE = 'jump-next'

const PLACEMENT = 'part-navigation'

type NavigateJumpIconPropsType = {
    type: string
}

const NavigateJumpIcon = (props: NavigateJumpIconPropsType) => {
    const { type } = props

    let ArrowIcon

    if (type === JUMP_PREV_NAVIGATE) {
        ArrowIcon = (
            <path d="M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" />
        )
    } else if (type === JUMP_NEXT_NAVIGATE) {
        ArrowIcon = (
            <path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" />
        )
    }

    return (
        <Link
            className="ant-pagination-item-link"
            data-test-target="jump-navigation-link"
            href="#"
            name="jump-nav"
            placement={PLACEMENT}
        >
            <div className="ant-pagination-item-container">
                <span className="anticon anticon-double-left ant-pagination-item-link-icon">
                    <svg
                        aria-hidden="true"
                        data-icon="double-left"
                        fill={getColor('white')}
                        focusable="false"
                        height="1em"
                        viewBox="64 64 896 896"
                        width="1em"
                    >
                        {ArrowIcon}
                    </svg>
                </span>
                <span
                    className="ant-pagination-item-ellipsis"
                    style={{ color: getColor('white') }}
                >
                    <EllipsisOutlined
                        style={{
                            fontSize: '20px',
                        }}
                    />
                </span>
            </div>
        </Link>
    )
}

export default NavigateJumpIcon
